import { create } from 'zustand'

import httpClient from '../httpClient'
import { apiErrorMessage } from '../lib/utils'

let requestId = 0

const usePhotographers = create((set, get) => ({
  photographers: null,
  error: null,
  loading: false,
  params: null,
  fetchPhotographers: async (params = get().params) => {
    if (!params) return

    requestId += 1
    const currentRequestId = requestId
    const { status, page, perPage, term } = params

    set({ loading: true, error: null, params })
    try {
      const photographers = await httpClient(term ? 'find_photographer' : 'photographers', {
        params: term ? { query: term } : { status, page, per_page: perPage },
      })

      if (currentRequestId === requestId) set({ photographers, loading: false })
    } catch (error) {
      if (currentRequestId === requestId) {
        set({ error: apiErrorMessage(error), loading: false })
      }
    }
  },
}))

export default usePhotographers
